<template>
    <div class="social-footer">
        <div class="divider"></div>
        <p class="title">Or continue with...</p>
        <div class="social-logins">
            <div
                v-for="login in socials"
                :key="login.name"
                @click="handleRedirectSocial(login, { mode: 'auth', role: role })"
                class="social-login"
            >
                <img :src="login.icon" :alt="login.name" />
                <p class="social-name">{{ login.name }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import { useAuthSocial } from '@/composables/auth/useAuthSocial'
    export default {
        name: 'AuthSocial',
        props: {
            role: {
                required: true,
                type: String,
                validator: (v) => ['user', 'venue', 'artist'].includes(v)
            }
        },
        setup(props) {
            const { socials, handleRedirectSocial } = useAuthSocial(props)

            return { socials, handleRedirectSocial }
        }
    }
</script>
<style lang="scss" scoped>
    .social-footer {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 24px;

        .divider {
            height: 1px;
            width: 100%;
            background: #8b8b8b;
        }
        .title {
            color: #8b8b8b;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            margin-left: 4%;
        }
        .social-logins {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            gap: 48px;

            .social-login {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 8px;
                cursor: pointer;

                .social-name {
                    color: #dedede;
                    text-align: center;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%; /* 16.2px */
                    letter-spacing: 0.12px;
                }
            }
        }
    }
</style>
